var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMailDs = function SvgMailDs(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87:9253)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3125 19.5283H6.6875C4.10281 19.5283 2 17.4592 2 14.9159V8.61237C2 6.06911 4.10281 4 6.6875 4H17.3125C19.8972 4 22 6.06911 22 8.61237V14.9159C22 17.4592 19.8972 19.5283 17.3125 19.5283ZM6.6875 5.53706C4.96438 5.53706 3.5625 6.91646 3.5625 8.61197V14.9155C3.5625 16.6111 4.96438 17.9905 6.6875 17.9905H17.3125C19.0356 17.9905 20.4375 16.6111 20.4375 14.9155V8.61197C20.4375 6.91646 19.0356 5.53706 17.3125 5.53706H6.6875ZM14.8627 13.1249L18.7242 10.2225C19.0671 9.96477 19.1328 9.48236 18.8708 9.14496C18.6089 8.80757 18.1187 8.74299 17.7758 9.00071L13.9147 11.9028C12.7998 12.7395 11.2428 12.7401 10.1272 11.9049L6.38576 9.0431C6.0451 8.78251 5.55424 8.84304 5.28947 9.17825C5.02467 9.51345 5.08615 9.99641 5.42682 10.257L9.17115 13.1209C9.17303 13.1224 9.17494 13.1238 9.17686 13.1252C10.0137 13.7533 11.0165 14.0673 12.0194 14.0673C13.0224 14.0673 14.0256 13.7531 14.8627 13.1249Z",
    fill: "#9496A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87:9253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMailDs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Mail-ds.1384820e251a7999a009a4b3f1e0f900.svg";